import { useCurrentModule } from '@hooks/useCurrentModule';
import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { isBrowser, isMobile, isTablet } from 'react-device-detect';

export const usePOSScreen = () => {
  const pathname = window.location.pathname?.split('/')?.[1];
  const theme = useTheme();
  const currentModuleState = useCurrentModule();

  const isSmallScreen = useMediaQuery('(max-width: 1200px)');
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktopScreen = useValidateDesktopScreen();

  const isPOS1024p = useMemo(() => {
    return (
      (isBrowser || isDesktopScreen || isSmallScreen) &&
      pathname === 'point-of-sale' &&
      isLgDown
    );
  }, [
    isBrowser,
    isDesktopScreen,
    isSmallScreen,
    currentModuleState,
    isLgDown,
    pathname,
  ]);

  return isPOS1024p;
};

export const usePOSMediumScreen = () => {
  const theme = useTheme();
  const pathname = window.location.pathname?.split('/')?.[1];
  const isSmDown = useMediaQuery(theme.breakpoints.down('md'));
  // const isMobileLandscape = useMediaQuery('(max-height: 480px)');
  // const isTabletLandscape = useMediaQuery('(max-height: 720px)');
  // const isShortScreen = useMediaQuery('(max-height: 800px)');

  const isPOSMediumScreen = useMemo(
    () => pathname === 'point-of-sale' && isSmDown,
    [pathname, isSmDown],
  );

  return isPOSMediumScreen;
};

export const useValidateDesktopScreen = () => {
  const ua = navigator?.userAgent?.toLowerCase();
  const isDesktopUA = !/mobile|android|iphone|ipad|tablet/i.test(ua ?? '');

  return isDesktopUA && !isMobile && !isTablet;
};
